<template>
  <span class="n-icon">
    <svg viewBox="0 0 24 24">
      <path :fill="fill" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </svg>
  </span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-add-icon',
});
</script>
